export default {
    use() {
        CanvasRenderingContext2D.prototype.ellipse = function (x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
            var rotateValue = rotation || 0;
            var startValue = startAngle || 0;
            var endValue = endAngle || 2 * Math.PI;
            var antiValue = antiClockwise || true;

            this.save();
            this.translate(x, y);
            this.rotate(rotation);
            this.scale(radiusX, radiusY);
            this.arc(0, 0, 1, startValue, endValue, antiValue);
            this.restore();
        }

        var pointsPainter = function (context, path) {
            if (!path.points && path.points.length < 2) return;

            context.strokeStyle = path.color;
            context.lineWidth = path.weight;
            context.moveTo(path.points[0].x, path.points[0].y);
            for (var j = 1; j < path.points.length; j++) {
                context.lineTo(path.points[j].x, path.points[j].y);
            }
            context.stroke();
        };
        var rectPainter = function (context, path) {
            if (!path.startPoint || !path.endPoint) return;

            context.strokeStyle = path.color;
            context.lineWidth = path.weight;
            var left = Math.min(path.startPoint.x, path.endPoint.x);
            var top = Math.min(path.startPoint.y, path.endPoint.y);
            var width = Math.abs(path.startPoint.x - path.endPoint.x);
            var height = Math.abs(path.startPoint.y - path.endPoint.y);
            if (width <= 0 || height <= 0) return;
            context.strokeRect(left, top, width, height);
        }
        var ellipsePainter = function (context, path) {
            if (!path.startPoint || !path.endPoint) return;

            context.strokeStyle = path.color;
            context.lineWidth = path.weight;
            var left = Math.min(path.startPoint.x, path.endPoint.x);
            var top = Math.min(path.startPoint.y, path.endPoint.y);
            var width = Math.abs(path.startPoint.x - path.endPoint.x);
            var height = Math.abs(path.startPoint.y - path.endPoint.y);
            if (width <= 0 || height <= 0) return;
            context.ellipse(left + width / 2, top + height / 2, width / 2, height / 2);
            context.stroke();
        }

        var painters = {
            'pen': pointsPainter,
            'rect': rectPainter,
            'ellipse': ellipsePainter
        };
        window.pathPainter = {
            create: function (type) {
                return painters[type];
            },
            paint: function (context, path) {
                var painter = painters[path.type];
                if (painter) painter(context, path);
            }
        }
    }
}